// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectPharmacyGroupsInStore,
  selectPharmacyGroupsPageLoading,
  selectPharmacyGroupsShowInitWaitingMessage,
} from '../_selectors/pharmacy-group.selectors';

export class PharmacyGroupsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectPharmacyGroupsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectPharmacyGroupsShowInitWaitingMessage));

    this.store
      .pipe(select(selectPharmacyGroupsInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
